import React from 'react';
import { LineChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToKeyGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToKeyGroupValue(panelData, chart);
                const hasGroups = data.some(d => d.group != null);
                const colorScale = buildColorScale(data);
                const options = {
                    ...buildXYChartOptions(chart),
                    legend: { enabled: hasGroups },
                    color: { scale: colorScale }
                };
                return <LineChart options={options} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
